import { useContext } from "react";
import { NotifyContext } from "../contexts";

export const useNotify = () => useContext(NotifyContext)